export default "__VITE_ASSET__CX96y1L$__"